module.exports = __webpack_public_path__ + "static/media/Student_Identification.9bae3988.pdf";